export const baseStyles = {
  border: 'var(--s1px) dashed var(--color-grey)',
  borderRadius: 'var(--s2px)',
  backgroundColor: 'var(--dragdrop-container-background-hover)',
};

export const draggingOverBorder =
  'var(--s2px) dashed var(--hovered-section-border-color)';

export const draggingOverBorderError =
  'var(--s2px) solid var(--color-red-error-dark-mode)';

export const draggingOverBackgroundColor = 'var(--background-primary)';
